export default {
  buttons: {
    accept: 'Accept',
    acceptType: 'Accept {{ type }}',
    addNew: 'Add new',
    addNewType: 'Add New {{ type }}',
    apply: 'Apply',
    applyType: 'Apply {{ type }}',
    back: 'Back',
    backType: 'Back {{ type }}',
    bulkAddNew: 'Bulk Add New',
    bulkAddNewType: 'Bulk Add New {{ type }}',
    cancel: 'Cancel',
    cancelType: 'Cancel {{ type }}',
    chooseFile: 'Choose File',
    clear: 'Clear',
    clearType: 'Clear {{ type }}',
    close: 'Close',
    closeType: 'Close {{ type }}',
    compare: 'Compare',
    compareType: 'Compare {{ type }}',
    confirm: 'Confirm',
    confirmType: 'Confirm {{ type }}',
    create: 'Create',
    createType: 'Create {{ type }}',
    delete: 'Delete',
    deleteType: 'Delete {{ type }}',
    download: 'Download',
    downloadType: 'Download {{ type }}',
    duplicate: 'Duplicate',
    duplicateType: 'Duplicate {{ type }}',
    edit: 'Edit',
    editType: 'Edit {{ type }}',
    export: 'Export',
    exportType: 'Export {{ type }}',
    get: 'Get',
    getType: 'Get {{ type }}',
    import: 'Import',
    importType: 'Import {{ type }}',
    learnMore: 'Learn More',
    next: 'Next',
    previous: 'Previous',
    print: 'Print',
    printType: 'Print {{ type }}',
    publish: 'Publish',
    publishType: 'Publish {{ type }}',
    readMore: 'Read More',
    reconcile: 'Reconcile',
    reconcileType: 'Reconcile {{ type }}',
    refund: 'Refund',
    refundType: 'Refund {{ type }}',
    rename: 'Rename',
    renameType: 'Rename {{ type }}',
    reset: 'Reset',
    resetType: 'Reset {{ type }}',
    revert: 'Revert',
    revertType: 'Revert {{ type }}',
    save: 'Save',
    saveType: 'Save {{ type }}',
    send: 'Send',
    sendType: 'Send {{ type }}',
    skip: 'Skip',
    submit: 'Submit',
    submitType: 'Submit {{ type }}',
    trial: 'Trial',
    trialType: 'Trial {{ type }}',
    view: 'View',
    viewType: 'View {{ type }}',
    withdraw: 'Withdraw',
    withdrawType: 'Withdraw {{ type }}',
  },
  dropZone: {
    dragFileToUpload: 'Drag file to upload',
    orDisjunctive: 'or',
  },
  errors: {
    api: 'There seems to be an issue connecting to our API, please try again or contact support',
    auth: 'There seems to be an authorization issue, please try logging out and in again.',
    general: {
      title: 'Oops! Looks like there has been a problem',
      body: 'If the error persists please contact support.',
    },
    save: 'There was a problem saving your data, please try again or contact support.',
  },
  loading: 'Loading...',
  noFilesChosen: 'No files chosen',
  noResults: 'There are no results to display.',
  noResultsType: 'There are no {{ type }} results to display.',
  toastNotifications: {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    cancelled: 'Cancelled',
  },
};
